import axios  from "axios";


const https = axios.create({
    // baseURL: 'http://localhost:8888/',
    baseURL:'http://www.xinhuoa.com:2363/',
    timeout:5*1000
})

https.interceptors.request.use(config=> {
      
  return config
},err=>{
    return Promise.reject(err)
})

https.interceptors.response.use(response=> {
    
    return response
},error => {
    //String(error).toLowerCase().indexOf('timeout')

})


export default https


// WEBPACK FOOTER //
// ./src/api/url.js